import { Injectable } from '@angular/core';

export interface BadgeItem {
  type: string;
  value: string;
}

export interface ChildrenItems {
  state: string;
  name: string;
  type?: string;
}

export interface Menu {
  state: string;
  name: string;
  type: string;
  icon: string;
  badge?: BadgeItem[];
  children?: ChildrenItems[];
}

const MENUITEMS = [

  {
    state: 'administration',
    name: 'Administration',
    type: 'sub',
    icon: 'settings',
    children: [
      {state: 'activites', name: 'Activités'},
      {state: 'cours', name: 'Cours'},
      {state: 'reservations', name: 'Réservations - Cours'},
      {state: 'resaespace', name: 'Réservations - Espace'},
      {state: 'espaces', name: 'Espaces'},
      {state: 'clients', name: 'Clients'},
      {state: 'utilisateurs', name: 'Utilisateurs'},
      {state: 'planpdf', name: 'Planning PDF'},
    ]
  }

];

@Injectable()
export class MenuItems {
  getAll(): Menu[] {
    return MENUITEMS;
  }

  add(menu: Menu) {
   // MENUITEMS.push(menu);
  }
}



// WEBPACK FOOTER //
// /home/codevi/Documents/PROJET/resa-parklife/front/src/app/shared/menu-items/menu-items.ts